export default {
    // "m" stand for "message"
    m: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        save: 'Guardar',
        success: 'Éxito',
        tip: 'Aviso',
        operateSuccess: '¡Opera con éxito!',
        addSuccess: '¡Añade con éxito!',
        editSuccess: '¡Modifica con éxito!',
        delSuccess: '¡Elimina con éxito!',
        delete: '¿Está seguro de eliminar esto?',
        edit: '¿Está seguro de modificar esto?',
        publish: '¿Está seguro de publicarlo?',
        resetPwd: '¿Está seguro de restablecer la contraseña? La contraseña restablecida se cambiará a: ',
        coursingOrExit: 'Se está produciendo el material didáctico. ¿Está seguro de salir?',
        paperingOrExit: 'e está produciendo el papel. ¿Está seguro de salir?',
        paperDataNotSave: 'Los datos actuales del papel no se guardarán. ¿Confirma continuar?',
        delCert: 'Esto va a eliminar el certificado para siempre. ¿Continúa?',
        titleRequired: '¡El título no puede estar vacío!',
        submitPaper: '¿Está seguro de entregar el papel?',
        submitUndonePaper: 'Todavía te queda {0} pregunta, ¿está seguro de entregar el papel?',
        practiceResult: 'Este ejercicio consiste en {0} pregunta, y usted respondió correctamente {1} pregunta',
        endingTime: '¡La fecha de sacar el certificado no debe ser inferior a la fecha de emisión!',
        checkCode: 'El código de verificación se ha enviado a su teléfono',
        signOut: '¿Está seguro de cerrar sesión?',
        cycleUser: '¿Está seguro de reciclar el usuario seleccionado?',
        deleteUser: '¿Está seguro de que desea eliminar permanentemente el usuario seleccionado?',
        pleaseComplete: '¡Rellene el formulario!',
        emptyMenuLogin: '¡Configure primero los datos del menú para esta cuenta!',
        startExam: '¿Estás seguro de comenzar el examen?',
        startResitExam: '¿Estás seguro de repetir el examen?',
        deleteImg: '¿Está seguro de eliminar esta {0} imagen?',
    },
    // "c" stand for "common" 各个组件公共的词条
    c: {
        all: 'Todos',
        back: 'Volver',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        reset: 'Restablecer',
        success: 'Éxito',
        operation: 'Operación',
        close: 'Cerrar',
        save: 'Guardar',
        input: 'De entrada',
        add: 'Añade',
        delete: 'Eliminar',
        edit: 'Editar',
        query: 'Consulta',
        view: 'Ver',
        preview: 'Vista previa',
        publish: 'Publicar',
        unpublish: 'Despublicar',
        share: 'Compartir',
        select: 'Seleccionar',
        submit: 'Entregar',
        finish: 'Terminar',
        others: 'Otros',
        settings: 'Ajustes',
        show: 'Mostrar',
        size: 'Tamaño',
        total: 'Total',
        to: 'A',
        prev: 'Anterior',
        next: 'Siguiente',
        fail: 'Fallar',
        yes: 'Sí',
        no: 'No',
        NO: 'Número',
        none: 'Nada',
        type: 'Tipo',
        status: 'Estado',
        description: 'Descripción',
        video: 'Vídeo',
        audio: 'Audio',
        image: 'Imagen',
        theory: 'Teórico',
        document: 'Documento',
        logOut: 'Cerrar sesión',
        date: 'Duración',
        from: 'Desde',
        startTime: 'Tiempo de inicio',
        endTime: 'Tiempo final',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha final',
        creator: 'Creador',
        creationTime: 'Tiempo de creación',
        makingTime: 'Tiempo de producción',
        modificationTime: 'Tiempo de modificación',
        modificationBy: 'Modificador',
        noData: 'Sin datos disponibles ahora',
        noMore: 'No mas',
        difficulty: 'Dificultad',
        knowledgePoint: 'Conocimientos',
        operatorLevel: 'Nivel aplicable',
        organizations: 'Organizaciones',
        belong: 'Pertenece a',
        trainingType: 'Tipo de formación',
        examType: 'Tipo de examen',
        position: 'Puesto',
        occupation: 'Ocupación',
        userInfo: 'Información personal',
        name: 'Nombre',
        username: 'Nombre',
        gender: 'Sexo',
        phone: 'Teléfono',
        role: 'Papel',
        grade: 'Habilidad',
        education: 'Educación',
        birthday: 'Cumpleaños',
        idCardNo: 'No. de tarjeta ID',
        idNo: 'No. de ID',  //jobNo
        account: 'Cuenta',  //accountNo
        downTemplate: 'Descargar la plantilla',
        import: 'Importar',
        male: 'Hombre',
        female: 'Mujer',
        desc: 'Descripción',
        coursewareLibrary: 'Biblioteca del material didáctico',
        producer: 'Productor',
        productionDate: 'Fecha de producción',
        modify: 'Modificar',
        making: 'Producir',
        resourceName: 'Nombre del recurso',
        problemNo: 'Número de la pregunta',
        right: 'TRUE',
        wrong: 'FALSE',
        error: 'Error',
        notAvailable: 'No disponible',
        detail: 'Detalles',
        option: 'Opciones',
        check: 'Seleccionar',
        noticeHoverTitle: 'Notificación de mensajes',
        noticeTitle: 'Aviso',
        noticeNone: 'Sin aviso',
        noticeClear: 'Eliminar aviso',
        upTrend: 'Subir (último mes)',
        trainAnalyse: 'Análisis de la formación (último mes)',
        quickEntry: 'Acceso rápido',
        seeMore: 'Ver más',
        trainFinish: 'Terminación de la formación',
        toEnd: 'Termina en',
        day: 'Día',
        hour: 'Hora',
        viewDetail: 'Ver detalles',
        recentWeek: 'Última semana',
        miles: 'Millas',
        open: 'Abrir',
        exam: 'Examen',
        practice: 'Práctica',
        learn: 'Estudio',
        completeTime: 'Tiempo de terminación',
        notYet: 'Todavía no',
        notGet: 'Nada',
        lookForward: 'Desarrollando, espera....',
        yearTime: 'Año',
        employmentDate: 'Hora de entrada',
        imageLearn:'Imagen aprendida',
        studyTime:'Tiempo total de estudio',
        learningStatistics:'Estadísticas del estado de ánimo',
        exportLearnStats:'Estatísticas de educação',
        clear:'Seleção clara',
        moment: 'hace un momento',
        yearAgo: 'hace años que',
        monthAgo: 'hace meses',
        weekAgo: 'hace semanas',
        dayAgo: 'hace días',
        hourAgo: 'horas atras',
        minuteAgo: 'hace minutos',
        unset: 'unset',
    },
    tip: {
        select: 'Seleccione',
        input: 'Introduzca el contenido',
        name: 'Introduzca el nombre',
        sysName: 'Introduzca el nombre de sistema',
        sysEnName: 'Introduzca el nombre de sistema (inglés)',
        sysShortName: 'Introduzca el nombre corto de sistema',
        sysVersion: 'Introduzca la versión de sistema',
        knowledgePoint: 'Seleccione los conocimientos',
        operatorLevel: 'Seleccione el nivel aplicable',
        belong: 'Seleccione la organización',
        trainingType: 'Seleccione el tipo de formación',
        examType: 'Seleccione el tipo de examen',
        orgName: 'Introduzca el nombre de la organización',
        userSearch: 'Introduzca el nombre y la cuenta',
        userSearchPlus: 'Introduzca el nombre, la cuenta y el teléfono',
        username: 'Introduzca el nombre del usuario',
        usernameOrNo: 'Introduzca el nombre de usuario o el número',
        usernameOrAccount: 'Introduzca el nombre de usuario o el número',
        idNo: 'Introduzca el número de ID',
        occupation: 'Seleccione la ocupación',
        grade: 'Seleccione la habilidad',
        position: 'Seleccione el puesto',
        gender: 'Seleccione el sexo',
        birthday: 'Seleccione el cumpleaños',
        idCardNo: 'Introduzca el número de la tarjeta ID',
        education: 'Seleccione la educación',
        path: 'Introduzca la ruta',
        icon: 'Introduzca el ícono',
        NO: 'Introduzca el número',
        remark: 'Introduzca la observación',
        time: 'Seleccione el tiempo',
        date: 'Seleccione la fecha',
        datetime: 'Seleccione el tiempo y la fecha',
        startTime: 'Seleccione la fecha inicial',
        endTime: 'Seleccione la fecha final',
        employmentDate: 'Elige el momento para unirte',
        reason: 'Seleccione una razón',
        courseName: 'Introduzca el nombre del material didáctico',
        producer: 'Introduzca el productor',
        courseType: 'Seleccione el tipo del material didáctico',
        hours: 'Introduzca las horas de clase',
        credits: 'Introduzca el crédito',
        addImg: 'Añada una imagen',
        problemNo: 'Introduzca el número de pregunta',
        creator: 'Introduzca el creador',
        difficulty: 'Introduzca la dificultad',
        titleDesc: 'Introduzca la descripción del título',
        chooseRightAnswer: 'Seleccione la respuesta correcta',
        optionDesc: 'Introduzca la descripción de la opción',
        paperName: 'Introduzca el nombre del papel',
        paperGroupType: 'Seleccione un modo de volumen de grupo',
        passLine: 'Introduzca la línea de aprobación',
        questionScore: 'Introduzca la calificación',
        paperType: 'Introduzca el tipo del papel',
        paperForm: 'Introduzca la forma del papel',
        perspective: 'Seleccione una perspectiva',
        account: 'Introduzca la cuenta',
        trainerName: 'Introduzca el nombre del estudiante',
        transcriptTitle: 'Introduzca el título del expediente académico',
        word: 'Introduzca el texto',
        title: 'Introduzca un título',
        option: 'Introduzca el contenido de la opción',
        trainName: 'Introduzca el nombre del plan de formación',
        oldPwd: 'Introduzca la contraseña antigua',
        newPwd: 'Introduzca la contraseña nueva',
        confirmPwd: 'Vuelva a introducir la contraseña nueva',
        mobile: 'Introduzca el número de teléfono',
        code: 'Introduzca el código de verificación',
        untie: 'Introduzca el código de verificación del teléfono para desenlazar',
        chooseGroupType: 'CT no admite actualmente la acumulación rápida. Vuelva a seleccionar un modo de volumen de grupo',
        txtContent: 'Área de contenido...',
        resName: 'Introduzca el nombre de recurso',
        imgUploadMaxSize: 'El tamaño de la imagen no puede exceder a {0}M',
        fileUploadMaxSize: 'El tamaño del archivo no puede superar los {0} M',
        fileExceedTip: 'Actualmente restringido para seleccionar {0} archivos, esta vez se seleccionan {1} archivos, se selecciona un total de {2} archivos',
        chooseOrgFirst: 'Seleccione primero una organización',
        queryOrg: 'Organización de consultas',
        chooseDueDate: 'Seleccione una fecha límite',
        chooseTopicSource: 'Seleccione la fuente de pregunta',
        uploader: 'Ingrese al cargador',
        knowTagTip: 'Ingrese una etiqueta',
        knowTypeTip: 'Seleccione el tipo de conocimiento',
        knowNameTip: 'Ingrese el nombre del conocimiento',
        knowDescTip: 'Ingrese la descripción del conocimiento',
        tipStart:'Seleccione la hora de inicio',
        tipEnd:'Seleccione la hora de finalización',
        type: 'Por favor elija el tipo',
    },
    rule: {
        lengthBetween: 'La longitud debe estar entre {0} y {1} carácter',
        maxLength: 'No excede de {0} carácter',
        idCardNo: 'Introduzca el número de identificación válido',
        required: 'Este campo es obligatorio',
        int: 'El valor no puede ser decimal',
        time: 'El tiempo debe ser más tarde que la hora actual',
        pwd: 'Reglas de la contraseña: de 12 a 20 dígitos, compuesta de números, letras y ciertos caracteres especiales _-#@&?*^=!.$%',
        pwdError: 'No cumple con las reglas de contraseña, vuelva a llenarlo',
        mobileNotExist: '¡El número de teléfono no existe!',
        mobileHasBound: 'El número se ha vinculado a otra cuenta',
        modifyPwd:'¡Por favor, cambie la contraseña!',
        codeError: 'Solo se admiten _-#@&?*^=!.$% Otros caracteres especiales'
    },
    system: {
        sysName: 'Nombre del sistema',
        sysEnName: 'Nombre del sistema (inglés)',
        sysShortName: 'Nombre corto del sistema',
        sysVersion: 'Versión del sistema',
        sysLogo: 'Logo del sistema',
        editSysLogo: 'Cambiar el logo del sistema',
        addOrg: 'Añadir una organización',
        orgDetail: 'Detalle de la organización',
        orgName: 'Nombre de la organización',
        orgDesc: 'Descripción de la organización',
        addUser: 'Añadir a un usuario',
        importUser: 'Importar a un usuario',
        editUser: 'Modificar a un usuario',
        cycleUser: 'Restaurar a usuarios',
        recoverUser: 'Restaurar a usuarios',
        deleteUser: 'Eliminar usuario',
        modifyRole: 'Modificar el papel',
        manageRole: 'Gestionar el papel',
        addRole: 'Añadir un papel',
        delRole: 'Eliminar el papel',
        resetPwd: 'Restablecer la contraseña',
        unselected: 'Sin seleccionar',
        selected: 'Seleccionado',
        changeAvatar: 'Cambiar mi foto de perfil',
        userProfile: 'Perfiles de usuario',
        trainRecord: 'Registros de formación',
        skillRecord: 'Evaluación de habilidades',
        result: 'Resultado',
        certificateName: 'Nombre del certificado',
        certAdd: 'Añadir un certificado',
        certDetail: 'Detalle del certificado',
        certificateNo: 'No. del certificado',
        level: 'Nivel',
        operateScore: 'Calificación de operación',
        theoryScore: 'Calificación teórica',
        releaseDate: 'Fecha de publicación',
        editMenu: 'Modificar menú',
        addMenu: 'Añadir menú',
        addSubmenu: 'Añadir submenú',
        parent: 'Pertenece a',
        path: 'Ruta',
        icon: 'Ícono',
        roleName: 'Nombre del papel',
        manageMember: 'Configurar miembros',
        manageMenu: 'Configurar menús',
        allMembers: 'Todos miembros',
        memberList: 'Lista de miembro',
        selectedMember: 'Miembros seleccionados',
        theoryKnowledge: 'Conocimientos teóricos',
        remark: 'Observaciones',
        exportUser: 'Exportar a usuario (criterios de filtro basados en la parte superior)',
        preJobApproval: 'Aprobación previa al trabajo',
        capabilityAnalyse: 'Análisis de capacidad',
        enabled: 'Activado',
        disabled: 'Desactivado',
        projectType: 'Tipo de proyecto',
        importOrg: 'Importar organización',
        exportOrg: 'Exportar organización',
    },
    user: {
        basicInfo: 'Información básica',
        postInfo: 'Informacion del trabajo',
        experienceInfo: 'Experiencia laboral',
        trainInfo: 'Record de entrenamiento',
        qualityInfo: 'Registro de control de calidad',
        rewardInfo: 'Información sobre recompensas y castigos',
        modifyInfo: 'Modificar registro',
        importDiploma: 'Importar fotos de certificados de graduación',
        exportBasicInfo: 'Exportar información básica',
        exportExtendInfo: 'Exportar detalles',
        userImportTemplate: 'Plantilla de importación de usuarios',
        userBasicImportTemplate: 'Plantilla de información básica del usuario',
        userExtendImportTemplate: 'Plantilla de detalles de usuario',
        zipImportTemplate: 'Plantilla de paquete comprimido',
        clickToDownload: 'Haga clic para descargar',
        chooseToDownload: 'Elija una de las siguientes plantillas para descargar:',
        startImport: 'Iniciar la subida',
        unbind: 'Unbound',
        bindTip: 'Necesita enlazar por usuario',
        nation: 'Nación',
        hometown: 'Pueblo natal',
        currentAddress: 'Domicilio actual',
        graduationSchool: 'Graduado',
        graduationDate: 'Fecha de Graduación',
        graduationDateTip: 'Seleccione la fecha de graduación',
        jobDate: 'Tiempo de participación en el trabajo',
        jobDateTip: 'Seleccione el horario de trabajo',
        securityCheckJobDate: 'Horas de trabajo para inspección de seguridad',
        securityCheckJobDateTip: 'Por favor elige',
        employmentDate: 'Tiempo de entrada',
        employmentDateTip: 'Por favor elige',
        diplomaPicture: 'Certificado de graduación y fotos de grado.',
        downloadFile: 'Descargar adjuntos',
        duty: 'Posición',
        jobTitle: 'Título profesional',
        backgroundReview: 'Revisión de antecedentes',
        certTip: 'Necesita agregar un certificado para este usuario en "Administración de certificados"',
        startEndTime: 'Hora de inicio y finalización',
        companyName: 'Nombre de empresa',
        addWorkExperience: 'Nueva experiencia laboral',
        editWorkExperience: 'Experiencia laboral editorial',
        addQuality: 'Agregar registros de control de calidad',
        editQuality: 'Modificar los registros de control de calidad',
        cause: 'Causa',
        dealResult: 'Resultado',
        addReward: 'Añadido recompensa y castigo información',
        editReward: 'Editar información sobre recompensas y castigos',
        rewardDetail: 'Recompensas y castigos específicos',
        punish: 'Castigo',
        reward: 'Recompensa',
        module: 'Módulo',
        ledgerRecord: 'Gestión de cuentas',
    },
    train: {
        name: 'Nombre de formación',
        type: 'Tipo de formación',
        percent: 'Progreso',
        memberNum: 'Número de estudiantes',
        site: 'Lugar de formación',
        classHour: 'Horas de clase',
        classScore: 'Créditos de entrenamiento',
        content: 'Contenido',
        time: 'Tiempo de formación',
        checkInTime: 'Tiempo de check-in',
        preTime: 'Tiempo de pre-publicación',
        dueTime: 'Fecha límite',
        addOnlineTrain: 'Añadir formación online',
        addOfflineTrain: 'Añadir formación offline',
        associatePaper: 'Papel de comentarios asociado',
        choosePaper: 'Papel de comentarios seleccionado',
        paperName: 'Nombre del papel de comentarios',
        surveyName: 'Nombre del papel de comentarios',
        confirmPublish: '¿Está seguro de publicarlo?',
        newOnlineTraining: 'Nueva formación online',
        newOfflineTraining: 'Nueva formación offline',
        editTraining: 'Modificar formación',
        basicInfo: 'Información básica',
        trainees: 'Participantes',
        courseSystem: 'Sistema del curso',
        chooseCourse: 'Seleccionar curso',
        chooseTestPaper: 'Seleccionar papel',
        chooseMockPaper: 'Seleccionar prueba simulada',
        chooseTip: 'Agregue procesos',
        testPeriod: 'Introduzca el período',
        editPaperTip: 'Edite el papel',
        addSuccess: '¡Plan de formación añadido con éxito!',
        editSuccess: '¡Plan de formación editado con éxito!',
        trainDetail: 'Detalle de formación',
        trainTrace: 'Rastreo de formación',
        planDetail: 'Detalle del plan de formación',
        progress: 'Progreso de formación',
        progressNow: 'Progreso actual',
        delTrainee: 'Retire a este estudiante',
        delTraineeConfirm: '¿Estás seguro de retirar a {0} fuera de formación?',
        addTrainee: 'Añadir estudiantes',
        reason: 'Razón',
        absentReason: 'Razones por ausencia',
        casualLeave: 'Baja por asunto personal',
        sickLeave: 'Baja por enfermedad',
        annualLeave: 'Vacaciones anuales',
        parentalLeave: 'Baja parental',
        maternityLeave: 'Baja por maternidad',
        paternityLeave: 'Baja por paternidad',
        passiveFinish: 'Acabado pasivo',
        credit: 'Crédito',
        hour: 'Horas de clase',
        times: 'Veces',
        resitTimes: 'Veces',
        qrCode: 'Generar un código de verificación',
        enlarge: 'Expandir/Doblar tabla',
        endDate: 'Fecha final',
        trainPlan: 'Plan de formación',
        signArea: 'Área de check-in',
        signPoint: 'Ubicación de check-in',
        userStatus: 'Estado de usuario',
        trainingMode: 'Modo de formación',
        currentOrg: 'Organización actualmente seleccionada',
        clickOrgFirst: 'Primero haga clic en la organización en el lado izquierdo , y seleccione una fecha límite',
        checkAllMembers: 'Haga lo siguiente para todos los miembros',
        advancedSettings: 'Configuración avanzada',
        advancedAccount: 'Introduzca el número de cuenta del estudiante o el número de trabajo, separado por espacios o salto de línea',
        advancedMaxError: '¡No exceda de 1000 cuentas!',
        extendEndTime: 'Extender la hora final',
        extendTip1: 'La hora final no puede ser inferior a la fecha actual',
        extendTip2: 'Cancelar la configuración de la hora final y extenderá el programa de formación indefinidamente',
        extendRule: 'Reglas',
        clonePlan: 'Clonar la formación',
        cloneTip1: 'Los estudiantes del curso de formación no serán clonados',
        cloneTip2: 'Si no se rellena el nombre de la formación, se utilizará el nombre del curso de formación clonado.',
        cloneSuccess: '¡Clonar con éxito!',
        group: 'Grupo',
        groupManage: 'Gestión del grupo',
        groupName: 'Nombre del grupo',
        groupAdd: 'Añadir grupo',
        groupEdit: 'Editar grupo',
    },
    course: {
        course: 'Material didáctico',
        name: 'Nombre del material didáctico',
        type: 'Tipo del material didáctico',
        sectionCannotDisplay: 'El recurso de esta sección no se puede mostrar por el momento',
        theoryCourseware: 'Material didáctico de teoría',
        chapter: 'Capítulo',
        theChapter: 'Capítulo {0}', // 重点翻译
        viewing: 'Consultar',
        myCourse: 'Mi material didáctico',
        theoryCoursewareMake: 'Producción del material didáctico teórico',
        theoryCoursewareEdit: 'Editar el material didáctico teórico',
        imageCoursewareMake: 'Producción del material didáctico de imagen',
        imageCoursewareEdit: 'Editar el material didáctico de imagen',
        imageCourseware: 'Material didáctico de imagen',
        addBaseInfo: 'Añadir información básica',
        addChapter: 'Añadir capítulo',
        addImage: 'Añadir imagen',
        courseCover: 'Cubierta del material didáctico',
        addCover: 'Añadir cubierta',
        deleteCover: 'Eliminar cubierta',
        coverTip: 'Nota: el tamaño de la imagen de la cubierta no debe ser superior a {0}M',
        coverTooBigMsg: '¡El tamaño de la imagen de la cubierta subida no debe ser superior a 2MB!',
        courseDesc: 'Descripción del material didáctico',
        courseNoImg: 'El material didáctico actual no tiene imagen, haga clic en el botón para añadir la imagen',
        imageName: 'Nombre de imagen',
        addImageDesc: 'Añadir descripción de la imagen',
        addImageDescInfo: 'Agregue la información de descripción de la imagen...',
        courseMakeSuccess: '¡Se produce el material didáctico con éxito!',
        curriculumSystem: 'Sistema del curso',
        chapterTitle: 'Introduzca el título del capítulo',
        sectionTitle: 'Introduzca el título de la sección',
        resourceSelection: 'Selección de recursos',
        fileUpload: 'Subir archivo',
        fastForward: 'Buscar adelante',
        noFastForward: 'No buscar adelante',
        learningTime: 'Tiempo de estudio',
        terminateUpload: 'Terminar la subida',
        imageUpload: 'Subir imagen',
        documentUpload: 'Subir documento',
        videoUpload: 'Subir vídeo',
        audioUpload: 'Subir audio',
        fileUploadFail: 'Error al subir archivos, vuelva a subirlos por favor',
        courseEditSuccess: '¡Edita el material didáctico con éxito!',
        marquee: 'Si enciende la lámpara de caballos trotadores',
        marqueeText: 'Introduzca el contenido de caballos trotadores',
        min: 'min',
        addTip: 'Nota: Bloquee el ratón en el cuadro de entrada del título del capítulo o sección y haga clic en Enter para agregar el capítulo o la sección',
        sectionDes: 'Introduzca la descripción de la sección...'
    },
    topic: {
        name: 'Título de pregunta',
        examPaperLibrary: 'Base de papeles de examen',
        detailView: 'Vista detallada',
        listView: 'Vista de lista',
        useTimes: 'Orden según veces usadas',
        rightRateSort: 'Orden según la precisión',
        rightRate: 'Precisión',
        default: 'Orden predeterminado',
        papersAssembleTimes: 'Veces de grupo',
        papersTimesSort: 'Orden según veces de grupo',
        papersAssembled: 'Veces de grupado',
        answerAnalysis: 'Análisis de respuestas',
        imageDesc: 'Descripción de la imagen',
        questionDesc: 'Descripción de la pregunta',
        myTopic: 'Mis preguntas',
        addTopic: 'Añadir pregunta',
        editTopic: 'Modificar pregunta',
        optionDesc: 'Descripción de la opción',
        rightOption: 'Opción correcta',
        addOrEditAnalyse: 'Añadir o modificar el análisis de preguntas',
        simulatedBag: 'Bolsa simulada',
        emptyPacket: 'Bolsa vacía',
        dangerous: 'Peligroso',
        chooseImage: 'Seleccionar imagen',
        addTopicDesc: 'Haga clic y agregue el análisis de preguntas',
        insertTip: 'Insertar TIP',
        editSaveSuccess: '¡Se guarda lo editado con éxito!',
        passLine: 'Línea de aprobación',
        mockPassLine: 'Línea de aprobación',
        leastOne: 'Elija al menos una pregunta',
        addTopicByPic: 'Importe imágenes para generar preguntas',
        excelDown: 'Descargar plantilla de Excel',
        excelImport: 'Importar Excel',
        wordDown: 'Descargar plantilla de Word',
        wordImport: 'Importar Word',
        tipAdjust: 'Ajuste de Tip',
        tipAdjustPanel: 'Panel de control y ajuste de Tip',
        zoom: 'Zoom',
        rotate: 'Rotar',
        physicalMap: 'Foto',
        attention: 'Atención',
        tipInsertAttention1: '1. No cambien de escala ni roten el Tip insertado en el paquete de doble vista',
        tipInsertAttention2: '2. Si la imagen de Tip excede a la del paquete durante el zoom o la rotación, arrastre y ajuste manualmente',
        tipInsertAttention3: '3. Seleccione un rango razonable para el zoom de Tip, trate de cumplir con la situación real',
    },
    paper: {
        paper: 'Papel de examen',
        myPaper: 'Mis papeles',
        theoryPaper: 'Papel teórico',
        theoryPaperMake: 'Producción del papel teórico',
        theoryPaperEdit: 'Editar el papel teórico',
        imagePaper: 'Papel de imagen',
        imagePaperMake: 'Producción del papel de imagen',
        imagePaperEdit: 'Editar el papel de imagen',
        name: 'Nombre del papel',
        type: 'Tipo del papel',
        form: 'Forma del papel',
        paperMethod: 'Método de compilación',
        testPeriod: 'Duración(min)',
        publishTime: 'Publicar la respuesta',
        publishTimeTip: 'Si no elige, la respuesta se publicará inmediatamente después del examen',
        allowReview: 'Revisar la respuesta',
        allowResit: 'Repetir el examen',
        allowResitTimes: 'Veces de repetición',
        resatTimes: 'Veces de repetición realizada',
        leaveTimes: 'Veces de cambio de pantalla',
        disorder: 'Desorden',
        questionType: 'Tipo de pregunta',
        single: 'Opción única',
        multiple: 'Opción múltiple',
        trueOrFalse: 'Verdadero o falso',
        buildupSmart: 'Acumulación inteligente',
        buildupChoose: 'Selección de temas',
        buildupImport: 'Importar papel de prueba',
        passScore: 'Calificación de aprobación',
        passingMark: 'Calificación de aprobación',
        totalScore: 'Calificación total',
        paperLibrary: 'Biblioteca de papeles',
        paperScore: 'Calificación del papel',
        editPaper: 'Editar preguntas',
        startPaper: 'Empezar a organizar el papel',
        randomGenPaper: 'Según las condiciones, se genera un papel seleccionando aleatoriamente las preguntas en la biblioteca de preguntas',
        chooseGenPaper: 'Marque las preguntas ideales para formar un papel',
        importGenPaper: 'Importe plantillas de Word y Excel, o introdúzcalas manualmente para generar rápidamente documentos de examen',
        chooseImportType: 'Seleccionar modo de importación',
        wordImport: 'Importar Word',
        wordUpload: 'Subir Word',
        excelImport: 'Importar Excel',
        excelUpload: 'Subir Excel',
        clickBtnAddTopic: 'No hay preguntas en el papel actual. Haga clic en el botón para agregar las preguntas',
        addTopic: 'Añadir pregunta',
        totalQuestions: 'Total de preguntas',
        totalScores: 'Calificación total',
        points: 'Punto',
        reimport: 'Reimportar',
        previewPaper: 'Vista previa',
        savePaper: 'Guardar',
        answer: 'Respuesta',
        analysis: 'Análisis',
        keyQuestion: 'Preguntas clave',
        keyQuestionAccuracy: 'Precisión de preguntas clave',
        backToTop: 'Volver arriba',
        chooseTopic: 'Seleccionar pregunta',
        topicSource: 'Fuente de pregunta',
        source: 'Fuente',
        editPaperSuccess: 'Se edita el papel de examen con éxito',
        theoryPaperMakeSuccess: 'Se produce el papel de examen teórico con éxito',
        imagePaperMakeSuccess: 'Se produce el papel de imagen con éxito',
        difficultDistribution: 'Distribución',
        simple: 'Fácil',
        medium: 'Medio',
        hard: 'Difícil',
        questionQuantity: 'Cantidad',
        scorePerQuestion: 'Calificación por pregunta',
        singleTotalNum: 'Opción única ({0})',
        multipleTotalNum: 'Opción múltiple ({0})',
        judgeTotalNum: 'Verdadero o falso ({0})',
        knowledgeTotalNum: 'Conocimientos ({0})',
        emptyPacketTotalNum: 'Paquete vacío ({0})',
        otherTotalNum: 'Otros ({0})',
        selectYourTopic: 'Pregunta seleccionada ({0})',
        paperNumGtOne: 'El papel de examen debe contener al menos una pregunta',
        paperNeddIncludeOneKP: 'El papel de examen debe contener al menos una pregunta de conocimientos',
        smartGroupSuccess: 'Papel de examen de grupo inteligente con éxito',
        imageTopic: 'Pregunta de imagen',
        dao: 'Número',
        eachTopic: 'Cada pregunta',
        setKeyTopic: 'Configurar la pregunta clave',
        accuracyRate: 'Precisión',
        buildupFast: 'Acumulación rápida',
        tipGenPaper: 'Inserte automáticamente el TIP y se genera rápidamente el papel de prueba',
        safeBag: 'Paquete seguro',
        selectKPTip: 'Haga clic en el lado derecho para seleccionar el tipo de conocimientos',
        ge: 'Número',
        emptyNum: 'Bolsa vacía',
        dangerNum: 'Peligroso',
        simulatedNum: 'Bolsa simulada',
        warnEmpty: 'Introduzca el número de paquete vacío',
        showAnswerAfterExam: 'Publicar la respuesta después de la prueba',
        mock: 'Examen simulado',
        mockTimes: 'Veces de examen simulado',
        chooseKpFirst: 'Seleccione conocimientos primero',
        exportPaper: 'Exportar el papel',
    },
    // 全屏的考试/练习页
    exam: {
        totalCount: 'El papel abarca',
        question: 'Número',
        min: 'min',
        score: 'Calificación',
        period: 'Período',
        answerSheet: 'Hoja de respuesta',
        singleMode: 'Modo único',
        multiMode: 'Modo múltiple',
        correct: 'Correcto',
        incorrect: 'Incorrecto',
        answered: 'Respondido',
        blank: 'Blanco',
        viewAnswer: 'Ver respuesta',
        prev: 'Anterior',
        next: 'Siguiente',
        submit: 'Entregar el papel',
        practiceTitle: 'Ejercicios de teoría',
        loading: 'Cargando...',
        result: 'Resultado de examen',
        practiceResult: 'Resultado de ejercicios',
        paperCount: 'Este papel contiene un total de',
    },
    //图库、资源管理
    res: {
        imgName: 'Nombre de imagen',
        imgType: 'Tipo de imagen',
        imgDesc: 'Descripción de la imagen',
        perspective: 'Vista',
        singleView: 'Vista única',
        doubleView: 'Vista doble',
        sideView: 'Vista doble',
        imgOrigin: 'Origen de imagen',
        file: 'Archivo',
        fileView: 'Vista del archivo',
        listView: 'Vista de lista',
        viewCT: 'Ver CT',
        viewDR: 'Ver DR',
        lastFile: 'Archivo anterior',
        nextFile: 'Archivo siguiente',
        editImg: 'Modificar la información de la imagen',
        resName: 'Nombre del recurso',
        resType: 'Tipo del recurso',
        checkAll: 'Seleccionar todo',
        cancelCheckAll: 'Cancelar todo',
        allFiles: 'Todos los archivos',
        upload: 'Subir',
        uploadTime: 'Tiempo Subir',
        rename: 'Renombrar',
        renameSuccess: 'Renombrado correctamente',
        progress: 'En curso...',
        renameTo: 'Cambiar el nombre a:',
        newFolder: 'Nueva carpeta',
        folderNameTip: 'Introduzca el nombre de la carpeta',
        folderNameIs: 'Nombre de la carpeta es:',
        newFolderSuccess: '¡Creado con éxito!',
        uploadStep: 'Subir proceso',
        success: 'Éxito',
        error: 'Error',
        uploading: 'Subiendo',
        paused: 'Pausado',
        waiting: 'Esperando',
        delete: 'Eliminar',
        fileList: 'Lista de archivos',
        chooseFile: 'Seleccionar archivos',
        expand: 'Expandir',
        fold: 'Doblar',
        noUploadFile: 'No hay archivos por cargar',
        checkMD5: 'Verificación de MD5',
        transcoding: 'Transcodificando',
        merging: 'Combinando',
        uploadFail: 'Subida fallada',
        copyTo: 'copiar a',
        moveTo: 'mover a',
        refresh: 'Actualizar',
        fileTotal: 'Total de {0} archivos',
        fileSize: 'Tamaño del archivo',
        playAudio: 'Reproducir audio',
        syncToLibrary: 'Sincronizarlo a la biblioteca de imágenes',
        bag: 'Paquete',
        editImage: 'Editar imagen',
        isDeleteAfterTB: 'Si la elimina o no',
        synchSuccess: '¡Sincroniza con éxito!',
        deleteMulti: '¿Está seguro de eliminar este {0} archivo?',
        fiscanImage: 'Detalles estadísticos de la imagen de Fisan',
        nuctechImage: 'Detalles de estadísticas de imagen de Nuctech',
    },
    cert: {
        holder: 'Titular del certificado',
        type: 'Tipo del certificado',
        date: 'Fecha',
        number: 'Número',
        issueDate: 'Fecha de emisión',
        reviewDate: 'Fecha de revisión',
        retrainDate: 'Fecha de reentrenamiento',
        releaseDate: 'Fecha de publicación',
        obtainDate: 'Fecha de obtención',
        addCert: 'Añadir un certificado',
        downCertTemp: 'Descargar la plantilla de certificado',
        upLoadCertTemp: 'Importar certificado',
        upLoadCertPic: 'Importar foto del certificado',
        exportCertTemp: 'Exportar certificado',
        downCertRetrain: 'Descargar la plantilla de reentrenamiento',
        upLoadCertRetrain: 'Importar el registro de reentrenamiento',
        editCert: 'Editar certificado',
        dangerCert: 'Certificado de mercancías peligrosas',
        proCert: 'Certificado de cualificación profesional',
        juniorProCert: 'Certificado de cualificación profesional primario',
        IntermediateProCert: 'Certificado de cualificación profesional intermedio',
        seniorProCert: 'Certificado de cualificación profesional superior',
        technicianProCert: 'Certificado de cualificación profesional de técnico',
        technicianProPlusCert: 'Certificado de cualificación profesional de técnico',
        certManage: 'Gestión del certificado',
        certAddTip: 'Agregar un certificado a esta persona',
        certAddTip_1: 'Agregue un certificado a esta persona en el lado izquierdo',
        howToTip: 'Seleccione a un titular en el lado izquierdo y añada un certificado',
        selectHolderTip: 'Seleccione a un titular del certificado',
        certInfo: 'Detalle del certificado',
        certName: 'Nombre del certificado',
        certNum: 'No. del certificado',
        theoryScore: 'Calificación teórica',
        operationScore: 'Calificación de operación',
        gradeName: 'Evaluación de calificación',
        retrain: 'Recapacitación',
        retrainRecord: 'Registro de recapacitación',
        retrainGrade: 'Calificación de recapacitación',
        obtainCert: 'Obtener certificado',
        trainSubject: 'Asignaturas de formación',
        trainInstitution: 'Órgano de formación',
        trainerName: 'Nombre del entrenador',
        personType: 'Categoría de personal',
        trainConclusion: 'Conclusión de la evaluación',
        qualified: 'Aprobado',
        good: 'Bien',
        excellent: 'Excelente',
        addRecord: 'Añadir registro',
        editRecord: 'Editar registro',
        selectUser: 'Seleccionar a un usuario',
        junior: 'P',
        Intermediate: 'M',
        senior: 'S',
        technician: 'T',
    },
    count: {
        quantity: 'Cantidad',
        certMember: 'Detalle del titular del certificado',
        viewType: 'Tipo de vista',
        singleView: 'Vista única',
        dualView: 'Vista doble',
        frequency: 'Frecuencia',
        resType: 'Tipo del recurso',
        uploadRank: 'Ranking de la cantidad subida',
        uploadNum: 'Cantidad subida',
        courseNum: 'Cantidad de material didáctico',
        theory: 'Teórico',
        topicType: 'Tipo de tema',
        topicDetail: 'Detalle de tema',
        topicNo: 'No. de tema',
        examName: 'Nombre de examen',
        examDuration: 'Duración de examen',
        score: 'Calificación',
        peopleNum: 'Número de personas',
        totalPeopleNum: 'Número de personas',
        passRate: 'Tasa de aprobación',
        passScore: 'Calificación de aprobación',
        averageScore: 'Calificación promedia',
        lowest: 'Calificación más baja',
        highest: 'Calificación más alta',
        examAttend: 'Debe asistir',
        attend: 'Asistido',
        examRealAttend: 'Asistir en realidad',
        absent: 'Ausente',
        examAbsence: 'Ausencia',
        passed: 'Aprobado',
        examPassNum: 'Número de personas aprobadas',
        failed: 'Suspendido',
        examFailNum: 'Número de personas suspendidas',
        countAnalysis: 'Análisis estadístico',
        paperScoreStatistic: 'Estadísticas de papeles de prueba',
        examDetailTitle: 'Estadísticas de examen',
        wrongRateTitle: 'Estadísticas de la tasa de respuestas incorrectas',
        rightNum: 'Correcto',
        wrongNum: 'Incorrecto',
        wrongRate: 'Tasa de respuestas incorrectas',
        scoreRank: 'Calificación',
        transcript: 'Reporte de calificaciones',
        exportStuDetail: 'Exportar detalles de respuesta de alumnos',
        exportTranscript: 'Exportar reporte de calificaciones',
        exportOffline: 'Exportar la lista de formación',
        print: 'Imprimir',
        printReview: 'Vista previa de impresión',
        exportDate: 'Fecha de exportación',
        timeConsume: 'Tiempo consumido',
        submitTime: 'Hora de entrega',
        ranking: 'Ranking',
        rankStatisticsTitle: 'Estadísticas de ranking',
        rankRangeTitle: 'Estadísticas del rango de ranking',
        feedback: 'Comentarios',
        trainDetailTitle: 'Estadísticas de detalles de formación',
        numStatistics: 'Estadísticas de cantidad',
        studyDuration: 'Duración',
        studyTime: 'Tiempo de estudio',
        studyNum: 'Suma de estudio',
        min: 'min',
        s: 's',
        personalStudyTitle: 'Estadísticas de estudio personal',
        finish: 'Acabado',
        unfinish: 'Inacabado',
        notStart: 'No empieza',
        processing: 'Procesando',
        absence: 'Ausencia',
        recover: 'Recuperación',
        registered: 'Registrado',
        normal: 'Normal',
        late: 'Tarde',
        error: 'Error',
        studentStatus: 'Estado',
        knowErrorRate: 'Tasa de conocimientos incorrectos',
        knowErrorRateStat: 'Estadísticas de la tasa de conocimientos incorrectos',
    },
    survey: {
        name: 'Nombre de encuesta',
        add: 'Añadir cuestionario',
        edit: 'Editar cuestionario',
        desc: 'Descripción de la encuesta',
        topic: 'Título de la encuesta',
        addOption: 'Añadir opciones',
        addTitleTip: 'Haga clic aquí para agregar un tema',
        subjective: 'Tema subjetivo',
        star1: 'Muy insatisfecho',
        star2: 'Insatisfecho',
        star3: 'Ordinario',
        star4: 'Satisfecho',
        star5: 'Muy satisfecho',
        responseNum: 'Número de encuestados',
        percentage: 'Porcentaje',
        detail: 'Detalle del cuestionario',
        statisticsTitle: 'Estadísticas del cuestionario de formación',
        publisher: 'Editor',
        validNum: 'Respuestas efectivas',
        satisfaction: 'Satisfacción',
        proportion: 'Proporción',
        synthesis: 'Síntesis',
        appraised: 'No evaluado (0)',
        average: 'Promedio:'
    },
    questionnaire: {
        name: 'Nombre del papel de comentarios',
        add: 'Añadir cuestionario',
        edit: 'Modificar cuestionario',
        desc: 'Descripción del cuestionario',
        topic: 'Tema del cuestionario',
        starTopic: 'Tema de calificación',
        startSurvey: 'Iniciar una investigación',
        peopleNum: 'Número de personas',
        defaultReport: 'Informe predeterminado',
        replyStatistics: 'Estadísticas de respuesta',
        NO: 'NO {0}',
        filterEmpty: 'Filtrar opciones vacías',
        replyTime: 'Tiempo de respuesta',
        replyTxt: 'Texto de respuesta',
        viewPaper: 'Ver el papel',
        startSuccess: '¡Lanzado con éxito!',
        maxLimit: 'Seleccionar {0} artículos como máximo',
        open: 'Abrir cuestionario',
        close: 'Cerrar cuestionario',
        export: 'Exportar cuestionario',
        confirmOpen: '¿Está seguro de abrir el cuestionario?',
        confirmClose: '¿Está seguro de cerrar el cuestionario?',
        successOpen: '¡Abre con éxito!',
        successClose: '¡Cierra con éxito!',
    },
    // 学员模块
    stu: {
        unfinished: 'Inacabado',
        finished: 'Acabado',
        studyProgress: 'Progreso del estudio',
        viewCourse: 'Ver el material didáctico',
        enterStudy: 'Empezar a estudiar',
        continueStudy: 'Seguir estudiando',
        viewPaper: 'Ver el papel',
        enterExam: 'Entrar en el examen',
        continueExam: 'Seguir el examen',
        enterMock: 'Entrar en el examen simulado',
        startResit: 'Empieza la repetición',
        resitStatus: 'Estado de repetición',
        resat: 'Repetido',
        allowResit: 'Repetición permitida',
        loadingExamTip: 'Cargando papeles de la prueba...',
        serverError: 'El servidor está desactivado~',
        loadPaperError: '¡No se pudo cargar datos de prueba!',
        topicNum: 'Preguntas',
        startPractice: 'Iniciar la práctica',
        startStudy: 'Iniciar el estudio',
        timeSetting: 'Ajustes del tiempo',
        set: 'Ajustes',
        notSet: 'No ajustar',
        singleTopic: 'Tema único',
        wholePaper: 'Todo el papel',
        practiceMode: 'Modo de práctica',
        quickJudge: 'Juicio rápido',
        markLocation: 'Marcar la ubicación',
        markLocationAndJudge: 'Marcar la ubicación y elegir la categoría',
        pass: 'Aprobar',
        passed: 'Aprobado',
        failed: 'Suspendido',
        passRate: 'Tasa de aprobación',
        theoryPractice: 'Ejercicios de teoría',
        imgPractice: 'Ejercicios de imagen',
        practiceDate: 'Fecha de práctica',
        timeoutNum: 'Horas extra',
        trainTask: 'Curso de formación',
        personal: 'Resumen',
        trainNum: 'Cursos de formación',
        testNum: 'Exámenes',
        exciseNum: 'Prácticas',
        imageNum: 'Estudios de imagen',
        errorStatistics: 'Estadísticas de preguntas incorrectas',
        isPass: 'Aprobación',
        testPass: 'Estadísticas de examen (A/S)',
        courseStudy: 'Estadísticas de estudio de material didáctico',
        imageAbility: 'Capacidad de imagen',
        theoryKP: 'Conocimientos teóricos',
        imageKP: 'Conocimientos de imagen',
        taskName: 'Nombre de formación',
        intoTask: 'Entrar',
        imgPracticeTip1: 'Primero, en el modo de juicio rápido se puede utilizar directamente las teclas de acceso directo [>], [?] para realizar el juicio de "aprobado" o "no aprobado"',
        imgPracticeTip2: 'Segundo, en el modo de práctica de juicio no rápido, el juicio es "peligroso" y sólo puede juzgarse marcando manualmente al sospechoso.',
        imgPracticeTip3: 'Tercero, después de configurar que la respuesta no puede ser modificada, solo se puede juzgar la imagen activada(con punto de destello)',
        imgPracticeTip4: 'Cuarto, la imagen anterior no se conservará durante el proceso de dibujo y la operación de modificar la imagen no es compatible con la imagen eliminada.',
        imgPracticeTip5: 'Quinto, cambio de velocidad [1, 2, 3], haga doble clic para marcar el tamaño del sospechoso con el fin de cambiar [z, x, c], pause el inicio [espacio] para cambiar',
        walkingPictureSetting: 'Configuración de camino',
        answerCanModify: 'La respuesta puede ser modificada',
        answerCannotModify: 'La respuesta no puede ser modificada',
        slow: 'Lento',
        normal: 'Normal',
        fast: 'Rápido',
        suspectColor: 'Color del marco',
        speed: 'Velocidad',
        pracitceNote: 'Práctica de atención',
        theoryAndImgPractice: 'Ejercicio teórico y de imagen',
        continuePractice: 'Sigue practicando',
        newPractice: 'Nueva práctica',
        unsubmitPracticeTip: 'No se ha entregado la práctica actual. ¿Desea continuar con la práctica actual?',
        imgStudyMenu: 'Estudio de imagen',
        imgPracticeMenu: 'Práctica de imagen',
        trackPracticeMenu: 'Práctica simulada',
        submitDate: 'Fecha de entrega',
        images: 'Imágenes',
        resultpf: 'Resultado',
        historyMockPaper: 'Pruebas de historia',
        enterExamTip: 'Una vez que el examen ha comenzado, el abandono a mitad de camino puede resultar en la falta de puntos. por favor, prepárese para el examen.',
        creditsEarned:'Credits earned',
        totalCredit: 'Creditos totales',
        monthCredit: 'Créditos del mes',
        allRank: 'Todas las clasificaciones',
        orgRank: 'Ranking institucional',
        creditDetail: 'Detalles de crédito',
        watchCreditDetail: 'Ver detalles de crédito',
        rankList: 'Tabla de clasificación',
        watchRankList: 'Ver la tabla de clasificación',
        myCreditRecord: 'Mi historial crediticio',
        rank: 'Rango',
        noRank: 'Sin clasificación'
    },
    prejob: {
        colorBlind: 'Ceguedad y debilidad del color',
        colorSensitive: 'Sensibilidad del color',
        spatialIntelligence: 'Inteligencia espacial',
        basicKnowledge: 'Conocimiento básico',
        dailyItems: 'Artículos diarios',
        dangerItems: 'Mercancías peligrosas',
        testTip: 'Avisos de prueba',
        startTest: 'Iniciar la prueba',
        quitTest: 'Salir de la prueba',
        submitTest: 'Entregar la prueba',
        tipDoNotClose: 'Avisos: no cierre el papel durante el examen.',
        tipOneChance: 'Sólo tienes una oportunidad, tómalo en serio por favor.',
        forReference: 'Nota: Este resultado de la prueba es solo para referencia.',
        tipProgress: 'Termine todas las pruebas para ver la evaluación final.',
        cheerUp: '¡Ánimo!',
        viewReport: 'Ver el informe de evaluación',
        reportTitle: 'informe de evaluación',
        rating: 'Nivel de evaluación',
        weakness: 'Conocimientos débiles',
        accuracy: 'Tasa de respuesta correcta',
        assessTitle: 'Hemos analizado los siguientes resultados en función de sus datos de evaluación',
        assessPerfect: 'Es perfecto en {0}',
        assessGood: 'Usted tiene una comprensión básica de {0}',
        assessBad: 'No es bueno en {0}, necesita hacer esfuerzos',
        assessCheerUp: 'Serás un buen inspector de seguridad. ¡Buena suerte!',
        notDone: 'No se ha terminado la evaluación previa al trabajo'
    },
    http: {
        error: 'Error en la conexión del servidor',
        forbidden: 'No tiene permiso',
        serverError: 'Error del servidor',
        timeout: 'Se agota el tiempo de espera de la solicitud'
    },
    app: {
        login: 'Iniciar sesión',
        portal: 'Portal',
        mobileSite: 'Inicio de sesión de teléfono móvil',
        switchTheme: 'Cambiar estilo de tema',
        signOut: 'Cerrar sesión',
        changePwd: 'Cambiar la contraseña',
        oldPwd: 'Contraseña antigua',
        newPwd: 'Contraseña nueva',
        confirmPwd: 'Confirmar la contraseña',
        errorPwd: '¡Las contraseñas entradas son contradictorias!',
        bindMobile: 'Vincular el móvil',
        mobile: 'Número de teléfono',
        code: 'Código de verificación',
        getCode: 'Obtener el código de verificación',
        getCodeAgain: 'Readquirir',
        waitCode: '{0}s después para volver a adquirir',
        bound: 'Ha vinculado el teléfono',
        unbound: 'El número de teléfono no está vinculado al usuario',
        untie: 'Desvincular',
        errorMobile: 'Introduzca el número de teléfono correcto',
        bindSuccess: '¡Vinculado con éxito!',
        untieSuccess: '¡Desvinculado con éxito!',
        account: 'Número de cuenta o número de teléfono',
        jobNo: 'Por favor ingrese el número de trabajo',
        enterpriseCode: 'Por favor ingrese el código de la compañía',
        roleType: 'Por favor seleccione un tipo de identidad',
        admin: 'Administrador',
        trainer: 'Entrenador',
        student: 'Estudiante',
        pwd: 'Su contraseña',
        logining: 'Iniciando sesión',
        loginNow: 'Iniciar sesión',
        forgetPwd: 'Olvidar la contraseña',
        retrievePwd: 'Recuperar la contraseña',
        pwdLogin: 'Iniciar sesión con contraseña',
        scanLogin: 'Iniciar sesión con escaneo',
        smsLogin: 'SMS',
        jobNoLogin: 'Número de trabajo',
        faceLogin: 'Reconocimiento facial',
        faceLoginClick: 'Haga clic para iniciar sesión con reconocimiento facial',
        confirmEdit: 'Confirmar la modificación',
        resetSuccess: 'Su contraseña se ha restablecido, saltará a la página de inicio de sesión después de {0}s',
        scanSuccess: '¡Inicio de sesión exitoso!',
        qrInvalid: 'El código QR ha caducado',
        freshQR: 'Actualizar el código QR',
        scanLoginTip: 'Escanear el código QR para iniciar sesión',
        appName: 'Nuctech',
        dashboard: 'Página de inicio',
        track: {
            trackTip: 'No actualice ni cierre la página durante el proceso de detección. Se recomienda mantener los rasgos faciales claros.',
            envMonitoring: 'Monitoreando el ambiente...',
            faceMonitoring: 'Monitoreando el retrato, mire la cámara',
            liveMonitoring: 'Retrato capturado con éxito,  detectando en vivo...',
            camera: 'Toma fotos después de {0}s, mantenga los ojos abiertos por favor',
            checking: 'Verificando...',
            loginSuccess: '¡Inicia sesión con éxito!'
        },
        copyright: '©2019, NUCTECH COMPANY LIMITED. All Rights Reserved',
    }
}
